import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setActiveTeamConversationToNull } from '../../../actions/teams';
import TeamsSidebarSelector from '../teams/TeamsSidebarSelector';
import {
	getUserDepartmentIds,
	isAssignedToUser,
	isUnassigned,
	isUnreadForUser
} from '@/utils/webchat/conversationAssignment';

import {
	Building2,
	ChevronDown,
	ChevronRight,
	Contact,
	Inbox,
	Mail,
	MailQuestion,
	MapPin,
	Phone,
	Tags,
	UsersRound,
	ChevronUp,
	MessagesSquare,
	ContactRound,
	Folders,
	FolderPlus
} from 'lucide-react';

import { CustomButton } from '@/components/ui/custom/CustomButton';
import { Button } from '@/components/ui/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger,
	DropdownMenuItem,
	DropdownMenuSeparator
} from '@/components/ui/dropdown-menu';
import {
	Select,
	SelectTrigger,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectSeparator
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { Separator } from '@/components/ui/separator';
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger
} from '@/components/ui/tooltip';
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger
} from '@/components/ui/collapsible';
import { IconButton } from '@/components/ui/custom/IconButton';

import FolderSelector from './FolderSelector';
import CreateFolderDialog from './CreateFolderDialog';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { setCustomerConversationAssignedType } from '@/actions/webchat';

class ConversationTypeSelector extends Component {
	state = {
		otherMenuOpen: false,
		departmentMenuOpen: false,
		groupsMenuOpen: null,
		directMessageMenuOpen: null,
		currentTagValue: null,
		currentUserSelected: null,
		allFoldersMenuOpen: false,
		showCreateFolderDialog: false
	};

	componentDidMount() {
		// check local storage and set the menu open state for groups and dms open state
		const groupsMenuOpenStateFromLocalStorage = localStorage.getItem(
			`${this.props.auth.user._id}-groupsMenuOpen`
		);

		if (groupsMenuOpenStateFromLocalStorage) {
			this.setState({
				groupsMenuOpen: JSON.parse(groupsMenuOpenStateFromLocalStorage)
			});
		}

		const directMessageMenuOpenStateFromLocalStorage = localStorage.getItem(
			`${this.props.auth.user._id}-directMessageMenuOpen`
		);

		if (directMessageMenuOpenStateFromLocalStorage) {
			this.setState({
				directMessageMenuOpen: JSON.parse(
					directMessageMenuOpenStateFromLocalStorage
				)
			});
		}
	}

	// saves the state of the Groups menu to local storage sets the state
	saveGroupsMenuOpenStateToLocalStorage = (open) => {
		localStorage.setItem(
			`${this.props.auth.user._id}-groupsMenuOpen`,
			open
		);
		this.setState({ groupsMenuOpen: open });
	};

	// saves the state of the Direct Messages men to local storage and sets the state
	saveDirectMessageMenuOpenStateToLocalStorage = (open) => {
		localStorage.setItem(
			`${this.props.auth.user._id}-directMessageMenuOpen`,
			open
		);
		this.setState({ directMessageMenuOpen: open });
	};

	onSelectConversationType = (newType) => {
		// this.props.setShowContacts(false);
		this.props.setCustomerConversationAssignedType(newType);
	};

	// type is either ALL, UNASSIGNED, MY_MESSAGES
	// if set is true, set the new state, otherwise just return the value
	// return is CustomerConversation[]
	filterCustomerConversationsByAssign = (type) => {
		const {
			customerConversations = [],
			auth,
			departments = []
		} = this.props;

		let filteredCustomerConversations = customerConversations;

		// if type === UNASSIGNED only show conversations with no assignees
		if (type === 'UNASSIGNED') {
			filteredCustomerConversations = customerConversations.filter(
				(convo) => isUnassigned(convo)
			);
		} else if (type === 'MY_MESSAGES') {
			// assigned to me directly, or to a department I belong to
			const userDepartmentIds = getUserDepartmentIds(
				departments,
				auth.user._id
			);
			filteredCustomerConversations = customerConversations.filter(
				(convo) =>
					isAssignedToUser(convo, auth.user._id, userDepartmentIds)
			);
		}

		// if TYPE === ALL, return all customer conversations. this is the default case
		return filteredCustomerConversations;
	};

	getHasUnreadMessages = (type) => {
		const { auth } = this.props;

		// conversations of selected style
		const typeConversations =
			this.filterCustomerConversationsByAssign(type);

		return typeConversations.some((c) => isUnreadForUser(c, auth.user));
	};

	getOpenedMessagesCount = (type) => {
		try {
			// conversations of selected style
			const typeConversations =
				this.filterCustomerConversationsByAssign(type);

			if (!typeConversations || !typeConversations.length) {
				return 0;
			}

			const unreadConversations = typeConversations.filter(
				(convo) => convo.open
			);

			return unreadConversations.length || 0;
		} catch {
			return '-';
		}
	};

	handleConversationTypeAndDashboard = (type) => {
		this.onSelectConversationType(type);
		if (this.props.active !== 'webchat') {
			this.props.setActiveTeamConversationToNull();
			this.props.setShowTeams(false);
		}
	};

	renderLocationSelector = () => {
		// remove this state

		const {
			assignedTypeSelected: selectedType,
			businessGroup,
			isCollapsed
		} = this.props;

		if (!businessGroup || !businessGroup.length) {
			return null;
		}

		if (isCollapsed) {
			return (
				<Tooltip>
					<DropdownMenu className="font-sans">
						<TooltipTrigger>
							<div>
								<DropdownMenuTrigger asChild>
									<Button
										variant={
											selectedType?.includes('LOCATION')
												? 'default'
												: 'ghost'
										}
										size="icon"
									>
										<MapPin className="h-4 w-4" />
									</Button>
								</DropdownMenuTrigger>
							</div>
						</TooltipTrigger>
						<TooltipContent side="right">Locations</TooltipContent>
						<DropdownMenuContent side="right" align="end">
							{[...businessGroup].map((business) => (
								<Link
									to={`/locations/${business._id}`}
									key={business._id}
								>
									<DropdownMenuItem
										key={business._id}
										className=" flex flex-col items-start"
										onClick={() => {
											this.handleConversationTypeAndDashboard(
												`LOCATION_${business._id}`
											);
										}}
									>
										{business.name || business.address}
										<p className="text-muted-foreground text-xs line-clamp-1 truncate">
											{business.address?.split(',')[0]}
										</p>
									</DropdownMenuItem>
								</Link>
							))}
						</DropdownMenuContent>
					</DropdownMenu>
				</Tooltip>
			);
		}

		return (
			<DropdownMenu className="font-sans">
				<DropdownMenuTrigger asChild>
					<Button
						variant={
							selectedType?.includes('LOCATION')
								? 'default'
								: 'ghost'
						}
						className="flex justify-between items-center pr-3"
					>
						<div className="flex gap-x-1 items-center">
							<MapPin className="h-4 w-4" />
							Locations
						</div>
						<ChevronDown className="h-4 w-4 opacity-50" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="end">
					{[...businessGroup].map((business) => (
						<Link
							to={`/locations/${business._id}`}
							key={business._id}
						>
							<DropdownMenuItem
								key={business._id}
								className=" flex flex-col items-start"
								onClick={() => {
									this.handleConversationTypeAndDashboard(
										`LOCATION_${business._id}`
									);
								}}
							>
								{business.name || business.address}
								<p className="text-muted-foreground text-xs line-clamp-1 truncate">
									{business.address?.split(',')[0]}
								</p>
							</DropdownMenuItem>
						</Link>
					))}
				</DropdownMenuContent>
			</DropdownMenu>
		);
	};

	renderDepartmentSelector = () => {
		const {
			assignedTypeSelected: selectedType,
			businessGroup,
			isCollapsed
		} = this.props;

		const { departments } = this.props;

		if (!departments || !departments.length) {
			return null;
		}

		const parts = businessGroup.map((b) => {
			const departmentsForBusiness = departments.filter(
				(d) => d.isActive && d._business === b._id
			);

			if (!departmentsForBusiness || !departmentsForBusiness.length) {
				return null;
			}

			return (
				<div key={b._id}>
					{businessGroup && businessGroup.length > 1 && (
						<DropdownMenuItem className="uppercase" disabled>
							{b.name}
						</DropdownMenuItem>
					)}
					<DropdownMenuSeparator />
					{departmentsForBusiness.map((department) => (
						<Link
							to={`/departments/${department._id}`}
							key={department._id}
						>
							<DropdownMenuItem
								key={department._id}
								onClick={() => {
									this.handleConversationTypeAndDashboard(
										`DEPARTMENT_${department._id}`
									);
								}}
							>
								{department.name || department.username}
							</DropdownMenuItem>{' '}
						</Link>
					))}
				</div>
			);
		});

		if (isCollapsed) {
			return (
				<Tooltip>
					<DropdownMenu className="font-sans">
						<TooltipTrigger>
							<div>
								<DropdownMenuTrigger asChild>
									<Button
										variant={
											selectedType?.includes('DEPARTMENT')
												? 'default'
												: 'ghost'
										}
										size="icon"
									>
										<Building2 className="h-4 w-4" />
									</Button>
								</DropdownMenuTrigger>
							</div>
						</TooltipTrigger>
						<TooltipContent side="right">
							Departments
						</TooltipContent>
						<DropdownMenuContent side="right" align="end">
							{parts}
						</DropdownMenuContent>
					</DropdownMenu>
				</Tooltip>
			);
		}

		return (
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button
						variant={
							selectedType?.includes('DEPARTMENT')
								? 'default'
								: 'ghost'
						}
						className="flex items-center justify-between pr-3"
					>
						<div className="flex items-center gap-x-1">
							<Building2 className="h-4 w-4" />
							Departments
						</div>
						<ChevronDown className="h-4 w-4 opacity-50" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="end">{parts}</DropdownMenuContent>
			</DropdownMenu>
		);
	};

	handleOtherUserSelector = (user) => {
		this.setState({ currentUserSelected: user._id });
		this.handleConversationTypeAndDashboard(`USER_${user._id}`);
		this.props.navigateToComponent(`/users/${user._id}`);
	};

	renderOtherUserSelector = () => {
		const {
			assignedTypeSelected: selectedType,
			businessGroup,
			isCollapsed
		} = this.props;

		const { users } = this.props;

		if (!users || !users.length) {
			return null;
		}

		const parts = businessGroup.map((b) => {
			return (
				<SelectGroup key={b._id}>
					{businessGroup && businessGroup.length > 1 && (
						<SelectLabel className="uppercase font-normal text-muted-foreground">
							{b.name}
						</SelectLabel>
					)}
					{users
						.sort((a, b) => {
							const nameA = (a.name || '').toString();
							const nameB = (b.name || '').toString();
							return nameA.localeCompare(nameB);
						})
						.filter(
							(user) =>
								user.active && user._temporaryBusiness === b._id
						)
						.map((user) => (
							<SelectItem
								key={user._id}
								onClick={() => {
									this.handleConversationTypeAndDashboard(
										`USER_${user._id}`
									);
								}}
								value={user}
							>
								{user.name || user.username}
							</SelectItem>
						))}
					<SelectSeparator />
				</SelectGroup>
			);
		});

		if (isCollapsed) {
			return (
				<Tooltip delayDuration={0}>
					<Select onValueChange={this.handleOtherUserSelector}>
						<TooltipTrigger asChild>
							<SelectTrigger
								withoutArrow
								className={cn(
									selectedType?.includes('USER_')
										? 'bg-primary text-primary-foreground'
										: 'hover:bg-accent hover:text-accent-foreground border-none bg-transparent font-medium'
								)}
							>
								<ContactRound className="h-4 w-4 text-foreground" />
							</SelectTrigger>
						</TooltipTrigger>
						<TooltipContent side="right">Team</TooltipContent>
						<SelectContent className="max-h-[400px]">
							<SelectGroup>{parts}</SelectGroup>
						</SelectContent>
					</Select>
				</Tooltip>
			);
		}

		return (
			<Select onValueChange={this.handleOtherUserSelector}>
				<SelectTrigger
					className={cn(
						'pl-4 border-none shadow-none',
						selectedType?.includes('USER_')
							? 'bg-primary text-primary-foreground'
							: 'hover:bg-accent hover:text-accent-foreground border-none bg-transparent font-medium'
					)}
				>
					<div
						className={cn(
							'flex items-center gap-x-1',
							selectedType?.includes('USER_')
								? 'text-primary-foreground'
								: 'text-foreground'
						)}
					>
						<ContactRound className="h-4 w-4" />
						Team
					</div>
				</SelectTrigger>
				<SelectContent className="max-h-[400px]" align="end">
					{parts}
				</SelectContent>
			</Select>
		);
	};

	handleTagChange = (tag) => {
		this.setState({ currentTagValue: tag });
		this.handleConversationTypeAndDashboard(`TAG_${tag}`);
		this.props.navigateToComponent(`/tags/${tag}`);
	};

	renderTagSelector = () => {
		const { assignedTypeSelected: selectedType, isCollapsed } = this.props;

		const { tags } = this.props;

		if (!tags || !tags.length) {
			return null;
		}

		if (isCollapsed) {
			return (
				<Tooltip delayDuration={0}>
					<Select onValueChange={this.handleTagChange}>
						<TooltipTrigger asChild>
							<SelectTrigger
								className={cn(
									selectedType?.includes('TAG_')
										? 'bg-primary text-primary-foreground'
										: 'hover:bg-accent hover:text-accent-foreground border-none bg-transparent font-medium'
								)}
							>
								<Tags className="h-4 w-4 text-foreground" />
							</SelectTrigger>
						</TooltipTrigger>
						<TooltipContent side="right">Tags</TooltipContent>
						<SelectContent className="max-h-[400px]">
							<SelectGroup>
								{tags
									.sort((a, b) => {
										const tagA = (a || '').toString();
										const tagB = (b || '').toString();
										return tagA.localeCompare(tagB);
									})
									.map((tag) => {
										return (
											tag && (
												<SelectItem
													key={tag}
													value={tag}
												>
													{tag}
												</SelectItem>
											)
										);
									})}
							</SelectGroup>
						</SelectContent>
					</Select>
				</Tooltip>
			);
		}

		return (
			<Select onValueChange={this.handleTagChange}>
				<SelectTrigger
					className={cn(
						'pl-4 border-none shadow-none',
						selectedType?.includes('TAG_')
							? 'bg-primary text-primary-foreground'
							: 'hover:bg-accent hover:text-accent-foreground border-none font-medium'
					)}
				>
					<div
						className={cn(
							'flex items-center gap-x-1',
							selectedType?.includes('TAG_')
								? 'text-primary-foreground'
								: 'text-foreground'
						)}
					>
						<Tags className="h-4 w-4" />
						Tags
					</div>
				</SelectTrigger>
				<SelectContent className="max-h-[400px]">
					<SelectGroup>
						{tags
							.sort((a, b) => {
								const tagA = (a || '').toString().toLowerCase();
								const tagB = (b || '').toString().toLowerCase();
								return tagA.localeCompare(tagB);
							})
							.map((tag) => {
								return (
									tag && (
										<SelectItem
											className="text-wrap break-words text-ellipsis"
											key={tag}
											value={tag}
										>
											{tag}
										</SelectItem>
									)
								);
							})}
					</SelectGroup>
					<SelectSeparator />
					<Link
						to="/settings/tag-manager"
						className="flex items-center gap-1 px-2 py-1.5 text-sm font-medium text-primary hover:text-primary hover:bg-primary/10 rounded-sm cursor-pointer whitespace-nowrap"
					>
						<span>Manage tags</span>
						<ChevronRight className="size-3" />
					</Link>
				</SelectContent>
			</Select>
		);
	};

	renderTeams = () => {
		const { isCollapsed, active } = this.props;

		if (this.props.auth.user.isEnterpriseEnabled) {
			return null;
		}

		const { assignedTypeSelected: selectedType, teams } = this.props;

		const unreadConversations =
			teams && teams.teamConversations
				? teams.teamConversations.filter((convo) =>
						convo._unreadUsers.includes(this.props.auth.user._id)
					)
				: [];

		const unreadDirectMessageConversations = unreadConversations.filter(
			(convo) => convo._users.length === 2 && convo.isDirectMessage
		);

		const unreadGroupConversations = unreadConversations.filter(
			(convo) => convo._users.length >= 2 && !convo.isDirectMessage
		);

		const handleDashboardChange = (type) => {
			this.props.setCustomerConversationAssignedType(type);
			// this.props.setShowTeams(true);
			if (active !== 'group-chat') {
				this.props.setShowTeams(true);
			}
		};

		return (
			<nav className="grid gap-1 px-2 group-data-[collapsed=true]:justify-center group-data-[collapsed=true]:px-2 pb-20">
				{isCollapsed ? (
					<Link to="/groupchat/groups">
						<IconButton
							toolTipTitle="Groups"
							toolTipSide="right"
							selected={selectedType === 'GROUPS'}
							onClick={() => {
								if (selectedType !== 'GROUPS') {
									this.props.setActiveTeamConversationToNull();
								}
								handleDashboardChange('GROUPS');
							}}
							className="space-x-1"
						>
							<UsersRound className="h-4 w-4" />
							{unreadGroupConversations.length > 0 && (
								<span
									className={cn(
										'flex h-2 w-2 rounded-full',
										selectedType === 'GROUPS'
											? 'bg-primary-foreground'
											: 'bg-primary'
									)}
								/>
							)}
						</IconButton>
					</Link>
				) : (
					<Collapsible open={this.state.groupsMenuOpen}>
						<div
							className={cn(
								'rounded-md flex justify-between',
								selectedType === 'GROUPS'
									? 'bg-primary text-primary-foreground hover:bg-primary/90'
									: 'hover:bg-accent hover:text-accent-foreground'
							)}
						>
							<CustomButton
								onClick={() => {
									if (selectedType !== 'GROUPS') {
										this.props.setActiveTeamConversationToNull();
									}
									handleDashboardChange('GROUPS');
									this.props.navigateToComponent(
										'/groupchat/groups'
									);
								}}
								className="w-full flex justify-start gap-x-2 items-center hover:bg-transparent hover:text-inherit"
							>
								<UsersRound className="h-4 w-4" />
								<p>Groups</p>
								{unreadGroupConversations.length > 0 && (
									<span
										className={cn(
											'flex h-2 w-2 rounded-full',
											selectedType === 'GROUPS'
												? 'bg-primary-foreground'
												: 'bg-primary'
										)}
									/>
								)}
							</CustomButton>
							<CollapsibleTrigger asChild>
								<CustomButton
									className="hover:bg-transparent px-3 py-2"
									onClick={() => {
										this.saveGroupsMenuOpenStateToLocalStorage(
											!this.state.groupsMenuOpen
										);
									}}
								>
									{this.state.groupsMenuOpen ? (
										<ChevronUp className="h-4 w-4 opacity-50" />
									) : (
										<ChevronDown className="h-4 w-4 opacity-50" />
									)}
								</CustomButton>
							</CollapsibleTrigger>
						</div>
						<CollapsibleContent className="w-full">
							<TeamsSidebarSelector
								teamConversationOpen={this.state.groupsMenuOpen}
								teamConversationType="GROUPS"
								setTeamConversationType={
									this.props
										.setCustomerConversationAssignedType
								}
								setShowTeams={this.props.setShowTeams}
								handleDashboardChange={handleDashboardChange}
								navigateToComponent={
									this.props.navigateToComponent
								}
							/>
						</CollapsibleContent>
					</Collapsible>
				)}
				{isCollapsed ? (
					<Link to="/groupchat/dms">
						<IconButton
							toolTipTitle="Direct Messages"
							toolTipSide="right"
							selected={selectedType === 'DIRECT_MESSAGES'}
							onClick={() => {
								if (selectedType !== 'DIRECT_MESSAGES') {
									this.props.setActiveTeamConversationToNull();
								}
								handleDashboardChange('DIRECT_MESSAGES');
							}}
							className="space-x-1"
						>
							<MessagesSquare className="h-4 w-4" />
							{unreadDirectMessageConversations.length > 0 && (
								<span
									className={cn(
										'flex h-2 w-2 rounded-full',
										selectedType === 'DIRECT_MESSAGES'
											? 'bg-primary-foreground'
											: 'bg-primary'
									)}
								/>
							)}
						</IconButton>
					</Link>
				) : (
					<Collapsible open={this.state.directMessageMenuOpen}>
						<div
							className={cn(
								'rounded-md w-full flex justify-between',
								selectedType === 'DIRECT_MESSAGES'
									? 'bg-primary text-primary-foreground hover:bg-primary/90'
									: 'hover:bg-accent hover:text-accent-foreground'
							)}
						>
							<CustomButton
								onClick={() => {
									if (selectedType !== 'DIRECT_MESSAGES') {
										this.props.setActiveTeamConversationToNull();
									}
									handleDashboardChange('DIRECT_MESSAGES');
									this.props.navigateToComponent(
										'/groupchat/dms'
									);
								}}
								className="w-full justify-start flex gap-x-2 items-center hover:bg-transparent hover:text-inherit"
							>
								<MessagesSquare className="h-4 w-4" />
								<p>Direct Messages</p>
								{unreadDirectMessageConversations.length >
									0 && (
									<span
										className={cn(
											'flex h-2 w-2 rounded-full',
											selectedType === 'DIRECT_MESSAGES'
												? 'bg-primary-foreground'
												: 'bg-primary'
										)}
									/>
								)}
							</CustomButton>
							<CollapsibleTrigger asChild>
								<CustomButton
									className="hover:bg-transparent px-3 py-2"
									onClick={() => {
										this.saveDirectMessageMenuOpenStateToLocalStorage(
											!this.state.directMessageMenuOpen
										);
									}}
								>
									{this.state.directMessageMenuOpen ? (
										<ChevronUp className="h-4 w-4 opacity-50" />
									) : (
										<ChevronDown className="h-4 w-4 opacity-50" />
									)}
								</CustomButton>
							</CollapsibleTrigger>
						</div>
						<CollapsibleContent>
							{this.props.auth.products &&
								this.props.auth.products.includes('teams') && (
									<TeamsSidebarSelector
										teamConversationOpen={
											this.state.directMessageMenuOpen
										}
										teamConversationType="DIRECT_MESSAGES"
										setTeamConversationType={
											this.props
												.setCustomerConversationAssignedType
										}
										setShowTeams={this.props.setShowTeams}
										handleDashboardChange={
											handleDashboardChange
										}
										navigateToComponent={
											this.props.navigateToComponent
										}
									/>
								)}
						</CollapsibleContent>
					</Collapsible>
				)}
			</nav>
		);
	};

	renderContactsList = () => {
		const { assignedTypeSelected: selectedType, isCollapsed } = this.props;

		return (
			<nav className="grid gap-1 px-2 group-data-[collapsed=true]:justify-center group-data-[collapsed=true]:px-2">
				{isCollapsed ? (
					<Tooltip>
						<TooltipTrigger asChild>
							<Button
								onClick={() => {
									this.props.setCustomerConversationAssignedType(
										'CONTACTS'
									);
									// this.props.setShowContacts(true);
								}}
								variant={
									selectedType === 'CONTACTS'
										? 'default'
										: 'ghost'
								}
							>
								<Contact className="h-4 w-4" />
							</Button>
						</TooltipTrigger>
						<TooltipContent side="right">Contacts</TooltipContent>
					</Tooltip>
				) : (
					<CustomButton
						onClick={() => {
							this.props.setCustomerConversationAssignedType(
								'CONTACTS'
							);
							// this.props.setShowContacts(true);
						}}
						className="flex items-center justify-between px-4"
						selected={selectedType === 'CONTACTS'}
					>
						<div className="flex items-center gap-x-1">
							<Contact className="h-4 w-4" />
							Contacts
						</div>
					</CustomButton>
				)}
			</nav>
		);
	};

	renderFoldersSelector = () => {
		const {
			assignedTypeSelected: selectedType,
			isCollapsed,
			customerConversations,
			folders
		} = this.props;

		const { showCreateFolderDialog } = this.state;

		const getUnreadConversationsCountForFolder = (_folder) => {
			return customerConversations.filter(
				(conversation) =>
					conversation._folder === _folder &&
					isUnreadForUser(conversation, this.props.auth.user)
			).length;
		};

		const doAnyFoldersHaveUnreadConversations =
			folders.length > 0
				? folders.filter((folder) => {
						return (
							getUnreadConversationsCountForFolder(folder._id) > 0
						);
					})
				: [];

		const handleToggleCreateFolderDialog = (
			showCreateFolderDialogState
		) => {
			this.setState({
				showCreateFolderDialog: showCreateFolderDialogState
			});
		};

		const doesCurrentFolderHaveUnreadConversations = (_folder) => {
			return getUnreadConversationsCountForFolder(_folder) > 0;
		};

		if (isCollapsed) {
			return (
				<FolderSelector
					selectedType={selectedType}
					doAnyFoldersHaveUnreadConversations={
						doAnyFoldersHaveUnreadConversations
					}
					setCustomerConversationAssignedType={
						this.handleConversationTypeAndDashboard
					}
					isCollapsed={isCollapsed}
					doesCurrentFolderHaveUnreadConversations={
						doesCurrentFolderHaveUnreadConversations
					}
				/>
			);
		}

		return (
			<Collapsible open={this.state.allFoldersMenuOpen}>
				<div
					className={cn(
						'rounded-md w-full flex justify-between',
						selectedType?.includes('FOLDER')
							? 'bg-primary text-primary-foreground hover:bg-primary/90'
							: 'hover:bg-accent hover:text-accent-foreground'
					)}
				>
					{folders.length > 0 ? (
						<CollapsibleTrigger asChild>
							<div className="flex items-center w-full justify-between">
								<div className="flex items-center gap-x-1 px-4 py-2">
									<Folders className="size-4" />
									<p className="text-sm">Folders</p>
									{doAnyFoldersHaveUnreadConversations.length >
										0 && (
										<span
											className={cn(
												'flex ml-0.5 h-2 w-2 rounded-full',
												selectedType?.includes('FOLDER')
													? 'bg-primary-foreground'
													: 'bg-primary'
											)}
										/>
									)}
								</div>
								<CustomButton
									className="hover:bg-transparent px-3 py-2"
									onClick={() => {
										this.setState({
											allFoldersMenuOpen:
												!this.state.allFoldersMenuOpen
										});
									}}
								>
									{this.state.allFoldersMenuOpen ? (
										<ChevronUp className="h-4 w-4 opacity-50" />
									) : (
										<ChevronDown className="h-4 w-4 opacity-50" />
									)}
								</CustomButton>
							</div>
						</CollapsibleTrigger>
					) : (
						<CreateFolderDialog
							open={showCreateFolderDialog}
							setOpen={handleToggleCreateFolderDialog}
						>
							<div className="flex items-center w-full justify-between">
								<div className="flex items-center gap-x-1 px-4 py-2">
									<Folders className="size-4" />
									<p className="text-sm">Folders</p>
								</div>

								<div
									className="h-10 px-3 py-3 cursor-pointer"
									onClick={() =>
										handleToggleCreateFolderDialog(true)
									}
								>
									<FolderPlus className=" size-4 text-muted-foreground" />
								</div>
							</div>
						</CreateFolderDialog>
					)}
				</div>
				{folders.length > 0 && (
					<CollapsibleContent className="ml-4 border-s-4 mt-1">
						<CreateFolderDialog
							open={showCreateFolderDialog}
							setOpen={handleToggleCreateFolderDialog}
						>
							<CustomButton
								onClick={() => {
									this.setState({
										open: true
									});
								}}
								className="w-full space-x-2 justify-start px-4 py-2 m-1"
							>
								<FolderPlus className="size-4 text-muted-foreground" />
								<p className="text-sm text-muted-foreground">
									Add Folder
								</p>
							</CustomButton>
						</CreateFolderDialog>

						{folders.map((folder) => {
							const conversationCount =
								customerConversations.filter(
									(conversation) =>
										conversation._folder === folder._id &&
										conversation.open
								).length;
							return (
								<FolderSelector
									key={folder._id}
									selectedType={selectedType}
									folder={folder}
									setCustomerConversationAssignedType={
										this.handleConversationTypeAndDashboard
									}
									conversationCount={conversationCount}
									deleteFolderFromAllCustomerConversations={
										this.props
											.deleteFolderFromAllCustomerConversations
									}
									doAnyFoldersHaveUnreadConversations={
										doAnyFoldersHaveUnreadConversations
									}
									doesCurrentFolderHaveUnreadConversations={
										doesCurrentFolderHaveUnreadConversations
									}
								/>
							);
						})}
					</CollapsibleContent>
				)}
			</Collapsible>
		);
	};

	renderConversationList = () => {
		const { assignedTypeSelected: selectedType, isCollapsed } = this.props;

		return (
			<nav className="grid gap-1 px-2 group-data-[collapsed=true]:justify-center group-data-[collapsed=true]:px-2">
				{isCollapsed ? (
					<>
						<Tooltip delayDuration={0}>
							<TooltipTrigger asChild>
								<Link to={'/inbox'}>
									<Button
										variant={
											selectedType === 'ALL'
												? 'default'
												: 'ghost'
										}
										onClick={() => {
											this.handleConversationTypeAndDashboard(
												'ALL'
											);
										}}
										size="icon"
										className="p-2 ml-2.5"
									>
										<Inbox className="h-4 w-4" />
									</Button>
								</Link>
							</TooltipTrigger>
							<TooltipContent
								side="right"
								className="flex items-center gap-4"
							>
								Inbox
								<span className="ml-auto">
									{this.getOpenedMessagesCount('ALL')}
								</span>
							</TooltipContent>
						</Tooltip>
						<Tooltip delayDuration={0}>
							<TooltipTrigger asChild>
								<Link to={'/unassigned'}>
									<Button
										onClick={() => {
											this.handleConversationTypeAndDashboard(
												'UNASSIGNED'
											);
										}}
										variant={
											selectedType === 'UNASSIGNED'
												? 'default'
												: 'ghost'
										}
										size="icon"
										className="p-2 ml-2.5"
									>
										<MailQuestion className="h-4 w-4" />
									</Button>
								</Link>
							</TooltipTrigger>
							<TooltipContent
								side="right"
								className="flex items-center gap-4"
							>
								Unassigned
								<span className="ml-auto">
									{this.getOpenedMessagesCount('UNASSIGNED')}
								</span>
							</TooltipContent>
						</Tooltip>
						<Tooltip delayDuration={0}>
							<TooltipTrigger asChild>
								<Link to={'/my-messages'}>
									<Button
										onClick={() => {
											this.handleConversationTypeAndDashboard(
												'MY_MESSAGES'
											);
										}}
										variant={
											selectedType === 'MY_MESSAGES'
												? 'default'
												: 'ghost'
										}
										size="icon"
										className="p-2 ml-2.5"
									>
										<Mail className="h-4 w-4" />
									</Button>
								</Link>
							</TooltipTrigger>
							<TooltipContent
								side="right"
								className="flex items-center gap-4"
							>
								My Messages
								<span className="ml-auto">
									{this.getOpenedMessagesCount('MY_MESSAGES')}
								</span>
							</TooltipContent>
						</Tooltip>
					</>
				) : (
					<>
						<Link to="/inbox">
							<CustomButton
								selected={selectedType === 'ALL'}
								onClick={() => {
									this.handleConversationTypeAndDashboard(
										'ALL'
									);
								}}
								className="flex justify-between items-center w-full"
							>
								<div className="flex items-center gap-x-1">
									<Inbox className="h-4 w-4" />

									<p>Inbox</p>
									{this.getHasUnreadMessages('ALL') && (
										<span
											className={cn(
												'flex ml-0.5 h-2 w-2 rounded-full',
												selectedType === 'ALL'
													? 'bg-primary-foreground'
													: 'bg-primary'
											)}
										/>
									)}
								</div>
								<p className="opacity-50 size-4 pl-2">
									{this.getOpenedMessagesCount('ALL')}
								</p>
							</CustomButton>
						</Link>
						<Link to="/unassigned">
							<CustomButton
								selected={selectedType === 'UNASSIGNED'}
								onClick={() => {
									this.handleConversationTypeAndDashboard(
										'UNASSIGNED'
									);
								}}
								className="flex justify-between items-center w-full"
							>
								<div className="flex items-center gap-x-1">
									<MailQuestion className="h-4 w-4" />
									Unassigned
									{this.getHasUnreadMessages(
										'UNASSIGNED'
									) && (
										<span
											className={cn(
												'flex ml-0.5 h-2 w-2 rounded-full',
												selectedType === 'UNASSIGNED'
													? 'bg-primary-foreground'
													: 'bg-primary'
											)}
										/>
									)}
								</div>
								<p className="opacity-50 size-4 pl-2">
									{this.getOpenedMessagesCount('UNASSIGNED')}
								</p>
							</CustomButton>
						</Link>
						<Link to="/my-messages">
							<CustomButton
								selected={selectedType === 'MY_MESSAGES'}
								className="flex items-center justify-between w-full"
								onClick={() => {
									this.handleConversationTypeAndDashboard(
										'MY_MESSAGES'
									);
								}}
							>
								<div className="flex items-center gap-x-1">
									<Mail className="h-4 w-4" /> My Messages
									{this.getHasUnreadMessages(
										'MY_MESSAGES'
									) && (
										<span
											className={cn(
												'flex ml-0.5 h-2 w-2 rounded-full',
												selectedType === 'MY_MESSAGES'
													? 'bg-primary-foreground'
													: 'bg-primary'
											)}
										/>
									)}
								</div>
								<p className="opacity-50 size-4 pl-2">
									{this.getOpenedMessagesCount('MY_MESSAGES')}
								</p>
							</CustomButton>
						</Link>
					</>
				)}

				{this.renderFoldersSelector()}
				{this.renderLocationSelector()}
				{this.renderDepartmentSelector()}
				{this.renderTagSelector()}
				{this.renderOtherUserSelector()}
			</nav>
		);
	};

	render() {
		const { isCollapsed } = this.props;

		return (
			<div
				data-collapsed={isCollapsed}
				className={cn(
					' group flex flex-col gap-2 py-2 data-[collapsed=true]:py-2 mb-5 h-full overflow-y-auto'
				)}
			>
				{this.renderConversationList()}
				<Separator />
				{this.renderTeams()}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		assignedTypeSelected: state.webchat.assignedTypeSelected,
		active: state.webchat.activeDashboard,
		brandColor: state.brandColor,
		auth: state.auth,
		users: state.users,
		tags: state.tags,
		departments: state.departments,
		businessGroup: state.businessGroup,
		teams: state.teams,
		folders: state.folders,
		customerConversations: state.webchat.customerConversations
	};
}

const ConnectedConversationTypeSelector = connect(mapStateToProps, {
	setActiveTeamConversationToNull,
	setCustomerConversationAssignedType
})(ConversationTypeSelector);

const ConversationTypeSelectorWrapper = ({
	deleteFolderFromAllCustomerConversations,
	setShowTeams,
	isCollapsed
}) => {
	const navigate = useNavigate();
	const location = useLocation();

	const navigateToComponent = (url) => {
		navigate(url);
	};

	return (
		<ConnectedConversationTypeSelector
			navigateToComponent={navigateToComponent}
			deleteFolderFromAllCustomerConversations={
				deleteFolderFromAllCustomerConversations
			}
			setShowTeams={setShowTeams}
			isCollapsed={isCollapsed}
			pathname={location.pathname}
		/>
	);
};

export default ConversationTypeSelectorWrapper;
